module.exports = __webpack_public_path__ + "static/media/super_party_pack_english_128.145c288f.png";